/**
 * About page — leadership contacts from CMS.
 */
(function () {
  'use strict';

  async function init() {
    await Troop936Content.renderPageBlock('about-intro', 'content-about-intro');
    await Troop936Content.renderPageBlock('about-philosophy', 'content-about-philosophy');
    await Troop936Content.renderPageBlock('about-goals', 'content-about-goals');

    const container = document.getElementById('leadership-list');
    const leaders = await Troop936Content.loadLeadership();
    container?.classList.remove('is-loading');

    if (!container) return;

    if (!leaders.length) {
      container.innerHTML = `
        <div class="card">
          <p><strong>Scoutmaster:</strong> <span data-setting="scoutmaster_name">David Cordle</span></p>
          <p>Email: <a data-setting="scoutmaster_email" href="mailto:davidrcordle@gmail.com">davidrcordle@gmail.com</a></p>
        </div>
      `;
      await Troop936Content.applySiteSettings();
      return;
    }

    const adults = leaders.filter((l) => !l.patrol);
    const patrols = leaders.filter((l) => l.patrol);

    let html = '';
    if (adults.length) {
      html += `<div class="leadership-grid">${adults.map(renderCard).join('')}</div>`;
    }
    if (patrols.length) {
      html += `<h3>Patrol leaders</h3><div class="leadership-grid">${patrols.map(renderCard).join('')}</div>`;
    }
    container.innerHTML = html || '<p class="muted">Leadership contacts coming soon.</p>';
  }

  function renderCard(l) {
    return `
      <article class="card leadership-card">
        <h3>${escapeHtml(l.name)}</h3>
        <p class="leadership-role">${escapeHtml(l.role)}${l.patrol ? ' · ' + escapeHtml(l.patrol) : ''}</p>
        ${l.email ? `<p><a href="mailto:${escapeAttr(l.email)}">${escapeHtml(l.email)}</a></p>` : ''}
        ${l.phone ? `<p><a href="tel:${escapeAttr(l.phone.replace(/\D/g, ''))}">${escapeHtml(l.phone)}</a></p>` : ''}
        ${l.bio ? `<p class="muted">${escapeHtml(l.bio)}</p>` : ''}
      </article>
    `;
  }

  function escapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/"/g, '&quot;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

export {};
